import { ICreatePesquisaSatisfacaoItemUseCase } from "../../../presentation/useCases/create/create_pesquisa_satisfacao_item_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreatePesquisaSatisfacaoItemUseCase
 */

export class CreatePesquisaSatisfacaoItemUseCase implements ICreatePesquisaSatisfacaoItemUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async createPesquisaSatisfacaoItem(
    idPesquisaSatisfacao: number,
    ordem: string,
    descricao: string,
  ): Promise<void> {
    await this.repository.createPesquisaSatisfacaoItem(
      idPesquisaSatisfacao,
      ordem,
      descricao,
    );
  }
}
